import { useEffect, useState } from "react";
import { API_VERSION } from "src/types";
import { useAuth } from "src/context";
import { useParams } from "react-router-dom";

export default () => {
  const { user: firebaseUser } = useAuth();
  const { application_id, dealerName } = useParams();
  const [showJSON, setShowJSON] = useState(true);

  const [responseData, setResponseData] = useState({
    json: null,
    html: null,
    error: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!firebaseUser || !application_id || !dealerName) return;

      const full_api_path = `/${API_VERSION}/${dealerName}/application/${application_id}/full`;
      // eslint-disable-next-line no-undef
      const full_api_url = new URL(full_api_path, __API_BASE_URL__).toString();

      try {
        const jwtToken = await firebaseUser.getIdToken();

        const response = await fetch(full_api_url, {
          headers: {
            Accept: showJSON ? "application/json" : "text/html",
            "x-jwt": jwtToken,
          },
        });

        const contentType = response.headers.get("Content-Type");

        if (contentType?.includes("application/json")) {
          /** @type {unknown} */
          const jsonData = await response.json();
          const parsedJson =
            jsonData !== null && typeof jsonData === "object" ? jsonData : null;
          setResponseData({ json: parsedJson, html: null, error: null });
        } else if (contentType?.includes("text/html")) {
          const htmlData = await response.text();
          setResponseData({ json: null, html: htmlData, error: null });
        } else {
          throw new Error("Unsupported content type: " + contentType);
        }
      } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        setResponseData({ json: null, html: null, error: message });
      }
    };

    void fetchData();
  }, [firebaseUser, application_id, dealerName, showJSON]);

  const { json, html, error } = responseData;

  if (error) return <p>Error: {error}</p>;

  /** @param {string} jsonString */
  const renderStyledJson = (jsonString) => {
    return jsonString.split(/([{}":])/).map((part, index) => {
      if (part === "{" || part === "}" || part == ":" || part == '"') {
        return (
          <b key={index} style={{ color: "#007acc" }}>
            {part}
          </b>
        );
      }
      return (
        <span key={index} style={{ color: "#333333" }}>
          {part}
        </span>
      );
    });
  };

  return (
    <div className="absolute inset-0">
      <button onClick={() => setShowJSON((prev) => !prev)}>
        {showJSON ? "Show HTML" : "Show JSON"}
      </button>

      {showJSON ? (
        <pre
          style={{
            lineHeight: "20px",
            border: "1px solid #DFDFDF",
            backgroundColor: "#F5F5F5",
            borderRadius: "16px",
            padding: "16px",
            margin: "16px",
            cursor: "pointer",
            color: "green",
          }}
        >
          {renderStyledJson(JSON.stringify(json, null, "\t"))}
        </pre>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: html }} />
      )}
    </div>
  );
};
